'use client'

import { useState } from 'react'
import { Klarna32 } from '@vinted/payment-icons'
import { Cell, Divider, Icon, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { ItemPageKlarnaPromoPluginModel } from '@marketplace-web/checkout-payments/checkout-payments-options-data'

import KlarnaPromoModal from '../../components/KlarnaPromoModal'

const ItemPageKlarnaPromoPlugin = ({ showKlarna }: ItemPageKlarnaPromoPluginModel) => {
  const translatePlugin = useTranslate('checkout.payment.klarna.item_page_plugin')
  const [isModalOpen, setIsModalOpen] = useState(false)

  if (!showKlarna) return null

  const icon = <Icon name={Klarna32} aria-hidden="true" testId="payment-method-icon-klarna" />

  const body = (
    <Text as="p" type="subtitle">
      {translatePlugin('body')}{' '}
      <button type="button" onClick={() => setIsModalOpen(true)}>
        <Text as="span" type="subtitle" theme="primary" clickable>
          {translatePlugin('more_details')}
        </Text>
      </button>
    </Text>
  )

  return (
    <div data-testid="item-page-klarna-plugin">
      <Spacer size="large" />
      <Divider />
      <Spacer size="large" />
      <Cell styling="tight" prefix={icon} body={body} />
      <Spacer />
      <KlarnaPromoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  )
}

export default ItemPageKlarnaPromoPlugin
